function resizeNavigation() {
  var navWidth = $('.main-nav').outerWidth();
  var extrasWidth = $('.main-nav .extras').outerWidth();
  var width = navWidth - extrasWidth;

  $('.main-nav .menu-holder').css('width', width);
}

function sidebarSticky() {
  var sticky = $('#Sticky').offset().top - 150;
  if ($(this).scrollTop() > sticky) {
    $('.sidebar-col aside').addClass('sticky');
  } else {
    $('.sidebar-col aside').removeClass('sticky');
  }
}

function resizeSidebar() {
  var width = $('.top-nav .logo').outerWidth();
  $('.sidebar-col').css('width', width);
}

function equalizeHeight() {
  var maxHeight = 0;
  if ($(window).width() > 767) {
    $(".hub-item").each(function () {
      if ($(this).height() > maxHeight) {
        maxHeight = $(this).height();
      }
    });
    $(".hub-item").height(maxHeight);
  } else {
    $(".hub-item").removeAttr('style');
  }
}


function equalizeWidth() {
  //Removed the classes from the buttons - they were not working correctly
  var maxWidth = 0;

  if ($(window).width() > 767) {
    $(".wp-block-button.same-width").each(function () {
      if ($(this).width() > maxWidth) {
        maxWidth = $(this).width();
      }
    });

    $(".wp-block-button.same-width").width(maxWidth);
  } else {
    $(".wp-block-button.same-width").removeAttr('style');
  }
}

$(document).ready(function () {
  $(".booking-form .formCol, .booking-form select, .booking-form select option").mouseout(function (e) {
    e.stopPropagation();
  });

  // delay fade entry animation
  // $('body').show();
  // setTimeout(function () {
  //     // resizeNavigation();
  //     $('#Loading').fadeOut('slow');
  //     $('html').css('overflow', 'initial');
  //     // equalizeHeight(); removed 1/10 KR
  //     equalizeWidth();
  // }, 850);

  //adds weather -- removed July 8, 2022 - KR
  // var currentWeather = $('.cur-temp').text();
  // $('.live-weather').text(currentWeather);

  $('img[src$=".svg"]').each(function () {
    $(this).addClass('style-svg');
  });


  //UNUSED
  //extras tray functionality
  $('.open-extras').click(function () {
    $('.extras').addClass('open');
  })
  $('.close-extras').click(function () {
    $('.extras').removeClass('open');
  });

  //season change modal
  $('.season-content.active .season-trigger').one('click', function () {
    var cookie = Cookies.get("wp-season");
    //checks to see if cookie exists
    if (Cookies.get('wp-visited') !== 'true') {
      if (cookie == 'summer') {
        $('#season-speedbump .modal .season').html('Summer');
      } else if (cookie == 'yearRound') {
        $('#season-speedbump .modal .season').html('Year Round');
      }
      $.fancybox.open({
        src: '#season-speedbump'
      });
    }
    //creates cookie
    Cookies.set('wp-visited', 'true', {
      expires: 7,
      path: '/'
    })

  });

  //adjusts nav after load
  // setTimeout(function () {
  // var navHeight = $('.top-nav').outerHeight();
  // $('.wrapper').css('padding-top', navHeight + 'px');
  // }, 200);

  //adds appropriate active classes
  $('.sidebar-nav > .page_item_has_children.current_page_item, .sidebar-nav > .page_item_has_children.current_page_parent, .sidebar-nav > .page_item_has_children.current_page_ancestor').addClass('active');

  //side nav accordion functionality
  $('.sidebar-nav > .page_item_has_children > a').after('<span></span>');
  $('.sidebar-nav > .page_item_has_children > span').click(function (e) {
    if ($(this).parent().hasClass('active')) {
      $(this).parent().toggleClass('active');
      $(this).parent().find('.children').first().slideToggle();
    } else {
      $('.sidebar-nav > .page_item_has_children').removeClass('active');
      $('.sidebar-nav > .page_item_has_children > .children').slideUp();
      $(this).parent().addClass('active');
      $(this).parent().find('.children').first().slideToggle();
    }
  });

  //prevents images from being dragged
  $('img').on('dragstart', function (event) {
    event.preventDefault();
  });

  $("body").on("contextmenu", "img", function (e) {
    return false;
  });

  //accordion functionality
  $('.accordion .accordion-item').click(function () {
    $('.accordion .accordion-item').not($(this)).removeClass('active');
    $('.accordion .accordion-item').not($(this)).find('.copy').slideUp();
    $(this).find('.copy').stop().slideToggle();
    $(this).toggleClass('active');
  });


  $(window).resize(function () {
    // resizeNavigation(); removed 1/10 KR
    $('.mega-menu-item > .mega-sub-menu').css('left', -($('.top-nav .logo').outerWidth() - 1));
  });



  $('.mega-menu-item > .mega-sub-menu').css('left', -($('.top-nav .logo').outerWidth() - 1));



  document.addEventListener('facetwp-refresh', function () {
    if (typeof FWP.facets['experience_date_range'] !== 'undefined' && FWP.facets['experience_date_range'][0] !== '' && FWP.facets['experience_date_range'][1] == '') {
      FWP.facets['experience_date_range'][1] = FWP.facets['experience_date_range'][0];
    }
    if (typeof FWP.facets['event_dates'] !== 'undefined' && FWP.facets['event_dates'][0] !== '' && FWP.facets['event_dates'][1] == '') {
      FWP.facets['event_dates'][1] = FWP.facets['event_dates'][0];
    }

  });

});